export function waitFor(time: number) {
  return new Promise((res) => {
    setTimeout(() => {
      res(undefined);
    }, time);
  });
}
